import Vue from "vue";
import Router from "vue-router";
import { isLoggedIn } from "@/data/authentication";

// Pages
require('@/components/pages/pages.js')

// Testing
// import PlaygroundPage from "@/components/pages/playground/playground.page.vue";

// Default (general)
import HomePage from "@/components/pages/home/home.page.vue";

// Specific
import LoginPage from "@/components/pages/login/login.page.vue";

import SchoolPage from "@/components/pages/school/school.page.vue";
import SchoolsPage from "@/components/pages/schools/schools.page.vue";
import ProjectPage from "@/components/pages/project/project.page.vue";
import ProjectsPage from "@/components/pages/projects/projects.page.vue";
import FaqsPage from "@/components/pages/faqs/faqs.page.vue";
import OutputPage from "@/components/pages/output/output.page.vue";


Vue.use(Router);

const router = new Router({
	mode: "history",
	routes: [
		{
			path: "/",
			name: "HomePage",
			component: HomePage,
			children: [
				{
					path: "/login",
					name: "LoginPage",
					components: {
						modal: LoginPage
					},
				}
			]
		},
		{
			path: "/schools",
			component: SchoolsPage,
			name: "SchoolsPage",
			meta: { requiresAuth: true }
		},
		{
			path: "/schools/:school",
			component: SchoolPage,
			name: "SchoolPage",
			meta: { requiresAuth: true }
		},
		{
			path: "/schools/:school/projects/:project",
			component: ProjectPage,
			name: "ProjectPage",
			meta: { requiresAuth: true }
		},
		{
			path: "/projects",
			component: ProjectsPage,
			name: "ProjectsPage",
			meta: { requiresAuth: true }
		},
		{
			path: "/projects/:project",
			component: ProjectPage,
			name: "ProjectPage",
			meta: { requiresAuth: true }
		},
		{
			path: "/faqs",
			component: FaqsPage,
			name: "FaqsPage",
			meta: { requiresAuth: true }
		},
		{
			path: "/output",
			component: OutputPage,
			name: "OutputPage",
			meta: { requiresAuth: true }
		},
	]
})

router.beforeEach((to, from, next) => { 
	if (to.matched.some(record => record.meta.requiresAuth)) {
		// this route requires auth, check if logged in
		// if not, redirect to login page.
		if (!isLoggedIn()) {
			next({
				path: '/login',
				query: { redirect: to.fullPath }
			})
		} else {
			next()
		}
	} else {
		next() // make sure to always call next()!
	}
})

export default router;



// WEBPACK FOOTER //
// ./src/router.js